'use strict'

import { on } from './dom'

export default function postToUrl(url, parameters, target) {
  var form, field

  form = document.createElement('form')
  form.setAttribute('method', 'post')
  form.setAttribute('action', url)
  if (target) {
    form.setAttribute('target', target)
  }
  form.style.display = 'none'

  for (var key in parameters) {
    field = document.createElement('input')
    field.setAttribute('type', 'hidden')

    field.setAttribute('name', key)
    field.setAttribute('value', parameters[key])

    form.appendChild(field)
  }

  document.body.appendChild(form)
  form.submit()
  if (target) {
    document.body.removeChild(form)
  }
}

function random(length) {
  var text = ''
  var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  for (var i = 0; i < length; i++ ) {
    text += chars.charAt(Math.floor(Math.random() * chars.length))
  }
  return text
}

on('click', 'a[data-method="post"]', function(event) {
  var target
  switch (event.button) {
  case 1:
    window.open('', target = random(64))
    event.preventDefault()
    postToUrl(this.getAttribute('href'), {}, target)
    break
  case 0:
    event.preventDefault()
    postToUrl(this.getAttribute('href'), {}, target)
  }
})